module.exports = __webpack_public_path__ + "static/media/d1.ea926f42.png";